module.exports = __webpack_public_path__ + "media/images/group-4d5b4d89d06e5d2c649db498cecf05b7.svg";